"use client"

import { ClockArrowDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ClockArrowDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ClockArrowDownIcon = component(Icon)({ as: ClockArrowDown })
